import React from "react";
import style from "./SpecialTable.module.css";
import { Link } from "react-router-dom";

export default function SpecialTable() {

    return(
        <div className={style.table_outer_container}>
            <h1 data-aos="fade-up">What Sets NuFolks Apart</h1>

            <div className={style.table_wrapper_container} data-aos="fade-up"  data-a0s-duration="1000" data-aos-offset="100">
                <table>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td> Technological Innovation in Talent Acquisition</td>
                            <td>Pioneering AI-driven recruitment with proprietary ATS, we transform talent acquisition through intelligent matching, predictive analytics, and precision-engineered candidate screening.</td>
                        </tr>

                        <tr>
                            <td>2</td>
                            <td>Accelerated Hiring Ecosystem</td>
                            <td>Our agile, technology-enhanced workflows compress traditional hiring timelines, delivering tailored staffing solutions that connect top talent with ideal opportunities in record time.</td>
                        </tr>

                        <tr>
                            <td>3</td>
                            <td>Ethical Foundations of Excellence</td>
                            <td>Integrity isn't just a word—it's our operational DNA. We consistently demonstrate transparency, reliability, and ethical commitment in every client interaction and candidate engagement.</td>
                        </tr>

                        <tr>
                            <td>4</td>
                            <td>Measurable Placement Expertise</td>
                            <td>Backed by deep industry insights and a robust track record of successful placements, we don't just fill roles we strategically align talent with organizational objectives across diverse sectors.</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>Strategic Talent Partnership</td>
                            <td>Beyond recruitment, we build enduring relationships. Our holistic approach provides strategic workforce guidance, ensuring continuous talent optimization and mutual long-term success.</td>
                        </tr>

                    </tbody>
                </table>
            </div>
            <div className={style.table_bottom_container}>
                <div>
                    Find Top Talent & Share Your CV
                </div>
                <div>
                    <Link to="/hire-a-talent" className={style.AboutUs_intro_button1}>Hire a Talent</Link>
                    <Link to="/jobs" className={style.AboutUs_intro_button2}>Find a Job</Link>
                </div>         
            </div>

        </div>
    )
}